import cx from 'classnames';
import React, { Component } from 'react';
import './style.scss';
import { Checkbox, notification } from 'antd';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader';
import { api, urls } from '../../../api/request';

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: this.getInitialInputState(),
      lastname: this.getInitialInputState(),
      company: '',
      phone: '',
      email: this.getInitialInputState(),
      acceptEarlyAccess: props.location.search === '?EarlyAccess',
      isPending: false,
    };
  }

  getInitialInputState = () => ({ value: '', hasError: false });

  getBasicFields = () => {
    const {
      firstname, lastname, company, phone, email,
    } = this.state;
    return [{
      name: 'firstname',
      value: firstname.value,
    }, {
      name: 'lastname',
      value: lastname.value,
    }, {
      name: 'email',
      value: email.value,
    }, {
      name: 'company',
      value: company,
    }, {
      name: 'phone',
      value: phone,
    }].filter(field => field.value !== '');
  };

  checkIsValidForm = () => ['firstname', 'lastname', 'email']
    .reduce((isValidForm, field) => {
      const hasError = this.state[field].value.trim() === '';
      this.setState(state => ({
        [field]: {
          ...state[field],
          hasError,
        },
      }));
      return !hasError && isValidForm;
    }, true);

  changeRequiredField = (key, value) => this.setState({ [key]: { hasError: false, value } });

  notifyDependOnResponse = (response) => {
    if (!response.error) {
      notification['success']({
        message: 'Successfully submitted',
        description: '',
      });
      this.setState({
        firstname: this.getInitialInputState(),
        lastname: this.getInitialInputState(),
        company: '',
        phone: '',
        email: this.getInitialInputState(),
      });
      this.props.close();
    } else {
      notification['error']({
        message: 'Something went wrong',
        description: response.code,
      });
    }
  };

  submitNotifyForm = async () => {
    const { acceptEarlyAccess } = this.state;
    if (this.checkIsValidForm()) {
      this.setState({ isPending: true });
      const response = await api.post(urls.notifyFormHub, {
        fields: [
          ...this.getBasicFields(),
          {
            name: 'sign_up_for_early_access',
            value: acceptEarlyAccess,
          },
        ],
      });
      this.setState({ isPending: false });
      this.notifyDependOnResponse(response);
    } else {
      notification['error']({
        message: 'Please enter required fields',
      });
    }
  };

  submitParticipationForm = async () => {
    if (this.checkIsValidForm()) {
      this.setState({ isPending: true });
      const response = await api.post(urls.participationFormHub, {
        fields: this.getBasicFields(),
      });
      this.setState({ isPending: false });
      this.notifyDependOnResponse(response);
    } else {
      notification['error']({
        message: 'Please enter required fields',
      });
    }
  };

  render() {
    const { isModal = false, title } = this.props;
    const {
      firstname, lastname, company, phone, email, acceptEarlyAccess, isPending,
    } = this.state;
    return (
      <div
        className="landing_notify_form"
        style={{ alignItems: isModal ? 'center' : 'flex-start', position: isModal ? 'unset' : 'relative' }}
      >
        {isPending && isModal && (
          <div className="landing_notify_form_wrapper">
            <Loader loaded={!isPending} color="#ffffff" />
          </div>
        )}
        <h2 style={{ textAlign: isModal ? 'center' : 'left' }}>{title}</h2>
        {!isModal && <h4>We will notify you when BandwidthFinder launches.</h4>}
        <input
          type="text"
          placeholder="First Name*"
          value={firstname.value}
          onChange={e => this.changeRequiredField('firstname', e.target.value)}
          className={cx(null, {
            error: firstname.hasError,
          })}
        />
        <input
          type="text"
          placeholder="Last Name*"
          value={lastname.value}
          onChange={e => this.changeRequiredField('lastname', e.target.value)}
          className={cx(null, {
            error: lastname.hasError,
          })}
        />
        <input
          type="text"
          placeholder="Company"
          value={company}
          onChange={e => this.setState({ company: e.target.value })}
        />
        <input
          type="tel"
          placeholder="Phone"
          value={phone}
          onChange={e => this.setState({ phone: e.target.value })}
        />
        <input
          type="email"
          placeholder="Email*"
          value={email.value}
          onChange={e => this.changeRequiredField('email', e.target.value)}
          className={cx(null, {
            error: email.hasError,
          })}
        />
        {!isModal && (
          <div className="landing_notify_form_early_access">
            <Checkbox
              checked={acceptEarlyAccess}
              onChange={() => this.setState(
                state => ({ acceptEarlyAccess: !state.acceptEarlyAccess }),
              )}
            >
              <h3>Request to participate in Early Access</h3>
            </Checkbox>
          </div>
        )}
        <button
          type="submit"
          onClick={isModal ? this.submitParticipationForm : this.submitNotifyForm}
          className="landing_notify_form_submit"
        >Submit
        </button>
      </div>
    );
  }
}

export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/view/screens/Landing/Form.jsx